module.exports = "<span [class.hidden]=\"!loading\" class=\"spinner-border spinner-border-sm mr-1\" role=\"status\" aria-hidden=\"true\"></span>"